module.exports = __webpack_public_path__ + "static/media/shingleWeatheredWood.7e32bb1d.png";